<template>
  <div class="checkout-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xxl-8 col-xl-7 col-lg-7">
          <div class="checkout-promobox">
            Have A Coupon Code?
            <router-link to="/login">
              Click Here To Enter Coupon Code
            </router-link>
          </div>
          <form action="#" class="checkout-form">
            <div class="row">
              <div class="col-lg-12">
                <h3 class="section-title mb-30">Billing Details</h3>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="fname">First name*</label>
                  <input
                    type="text"
                    name="fname"
                    id="fname"
                    placeholder="First name here"
                    required
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="lname">Last name*</label>
                  <input
                    type="text"
                    name="lname"
                    id="lname"
                    placeholder="Last name here"
                    required
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="cname">Company name*</label>
                  <input
                    type="text"
                    name="cname"
                    id="cname"
                    placeholder="Company name here(Optional)"
                    required
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="select_country">Country/Region*</label>
                  <select name="select_country" id="select_country">
                    <option value="0" data-display="Country">Country</option>
                    <option value="1">United States</option>
                    <option value="2">Germany</option>
                    <option value="3">Russia</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="select_city">Town/City*</label>
                  <select name="select_city" id="select_city">
                    <option value="0" data-display="City">City</option>
                    <option value="1">New York</option>
                    <option value="2">Florida</option>
                    <option value="3">Los Angels</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="select_state">State</label>
                  <select name="select_state" id="select_state">
                    <option value="0" data-display="City">City</option>
                    <option value="1">New York</option>
                    <option value="2">Florida</option>
                    <option value="3">Los Angels</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="zip">ZIP Code</label>
                  <input
                    type="text"
                    name="zip"
                    id="zip"
                    placeholder="ZIP Code"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="phone">Phone</label>
                  <input
                    type="number"
                    name="phone"
                    id="phone"
                    placeholder="Phone Number"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="email">Email Address*</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    required
                  />
                </div>
              </div>
              <div class="col-lg-12 mb-3">
                <div class="checkbox">
                  <input type="checkbox" id="test_30" />
                  <label for="test_30">Ship To A Different Address?</label>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="">Order Notes(optional)</label>
                  <textarea
                    name="msg"
                    id="msg"
                    cols="30"
                    rows="10"
                    class="resize-0"
                    placeholder="Order Note"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="checkbox">
                  <input type="checkbox" id="test_10" />
                  <label for="test_10">
                    I have read And Accept the
                    <router-link class="link style1" to="/terms-conditions">
                      Terms &amp; Conditions
                    </router-link>
                  </label>
                </div>
              </div>
              <div class="col-lg-12 mt-4">
                <div class="form-group mb-0">
                  <button type="button" class="btn style-one">
                    Save Information
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-xxl-4 col-xl-5 col-lg-5">
          <div class="sidebar style-two">
            <div class="sidebar-widget bg-magnolia round-10 br-one">
              <h3 class="sidebar-widget-title">Your Orders</h3>
              <div class="cart-total">
                <div class="cart-total-wrap mb-0">
                  <div class="cart-total-item">
                    <p class="text_secondary f-secondary">
                      Graphic Design Book x 03
                    </p>
                    <span class="text_secondary f-secondary">$45.90</span>
                  </div>
                  <div class="cart-total-item">
                    <p class="text_secondary f-secondary">Coffee Guide x02</p>
                    <span class="text_secondary f-secondary">$41.00</span>
                  </div>
                  <div class="cart-total-item">
                    <p class="text_secondary f-secondary">
                      Graphic Design Book x 01
                    </p>
                    <span class="text_secondary f-secondary">$59.00</span>
                  </div>
                  <div class="cart-total-item">
                    <b class="fs-18 text_secondary f-secondary">Subtotal</b>
                    <span class="fs-18 text_secondary f-secondary">
                      $200.00
                    </span>
                  </div>
                  <div class="cart-total-item">
                    <p class="fs-18 text_secondary f-secondary">Shipping</p>
                    <span class="fs-18 text_secondary f-secondary">
                      Flat rate
                    </span>
                  </div>
                  <div class="cart-total-item">
                    <p class="fs-24 text_secondary f-secondary"><b>Total</b></p>
                    <span class="fs-24 text_secondary f-secondary">
                      <b>$340.00</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="sidebar-widget bg-magnolia round-10 br-one">
              <h3 class="sidebar-widget-title">Payment Method</h3>
              <div class="checkout-details">
                <div class="bill-details">
                  <div class="select-payment-method mt-20">
                    <div>
                      <input type="radio" id="test1" name="radio-group" />
                      <label for="test1">
                        Make your payment directly into our bank account. Please
                        use your Order ID as the payment reference.
                      </label>
                    </div>
                    <div>
                      <input type="radio" id="test3" name="radio-group" />
                      <label for="test3">Check Payment</label>
                    </div>
                    <div>
                      <input type="radio" id="test2" name="radio-group" />
                      <label for="test2">Cash On Delivery</label>
                    </div>
                  </div>
                  <div class="form-check checkbox style2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="test_2"
                    />
                    <label class="form-check-label" for="test_2">
                      I've read & accept the
                      <router-link to="/terms-conditions">
                        Terms & Conditions
                      </router-link>
                    </label>
                  </div>
                  <div class="checkout-footer mt-4">
                    <button
                      type="button"
                      class="btn style-one d-block w-100 mt-10"
                    >
                      Place Order
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutContent",
};
</script>